// extracted by mini-css-extract-plugin
module.exports = {"link":"StrengthTestTable_link__NOtGi"};